import { render, staticRenderFns } from "./PipeMaterialTab.vue?vue&type=template&id=ebe9c820&scoped=true"
import script from "./PipeMaterialTab.vue?vue&type=script&lang=ts"
export * from "./PipeMaterialTab.vue?vue&type=script&lang=ts"
import style0 from "./PipeMaterialTab.vue?vue&type=style&index=0&id=ebe9c820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe9c820",
  null
  
)

export default component.exports